<template>
  <v-menu
    v-model="menuRef"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="dateFormatted"
        dense
        outlined
        :hide-details="hideDetails"
        :clearable="canInputBeCleared"
        :label="label"
        :prepend-inner-icon="icons.mdiCalendarToday"
        :rules="rules"
        :readonly="readonly"
        :disabled="disabled"
        :filled="readonly"
        v-bind="attrs"
        v-on="on"
        @blur="dateIsoLocale = functions.parseDate(dateFormatted)"
        @click:clear="clearDateIso"
      />
    </template>

    <v-date-picker
      v-if="!readonly"
      v-model="dateIsoLocale"
      no-title
      color="primary"
      locale="pt-br"
      :min="minDateIso"
      @input="menuRef = false"
    />
  </v-menu>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiCalendarToday } from '@mdi/js'
import { required } from '@/@core/utils/validation'

export default {
  emits: ['update:dateIso'],

  props: {
    dateIso: {
      type: String,
      default: null,
    },
    minDateIso: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    required: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    hideDetails: Boolean,
  },

  setup(props, { emit }) {
    const menuRef = ref(null)
    const dateIsoLocale = ref(null)

    function formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    }

    function parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    const canInputBeCleared = computed(() => !props.readonly && !props.disabled)
    const rules = computed(() => (props.required ? [required] : []))
    const dateFormatted = computed(() => formatDate(dateIsoLocale.value))

    function clearDateIso() {
      dateIsoLocale.value = null
      emit('update:dateIso', null)
    }

    watch(
      () => props.dateIso,
      v => {
        dateIsoLocale.value = v
      },
      {
        immediate: true,
      },
    )

    watch(
      dateIsoLocale,
      v => {
        emit('update:dateIso', v)
      },
    )

    return {
      menuRef,
      dateIsoLocale,
      dateFormatted,
      canInputBeCleared,
      rules,
      clearDateIso,
      functions: {
        parseDate,
      },
      icons: {
        mdiCalendarToday,
      },
    }
  },
}
</script>
